import { useEffect } from 'react';
import { toast, Zoom } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const shownToasts = new Map();

function ToastInfo({ message, autoClose = 1500 }) {
  useEffect(() => {
    if (!message) return;

    const timeBeforeDelete = 2000;
    const now = Date.now();
    const previous = shownToasts.get(message);

    if (previous && now - previous < timeBeforeDelete) {
      return;
    }

    shownToasts.set(message, now);

    toast.info(message, {
      position: 'top-center',
      autoClose: autoClose,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: 'light',
      transition: Zoom,
    });

    setTimeout(() => {
      shownToasts.delete(message);
    }, timeBeforeDelete);
  }, [message, autoClose]);

  return null;
}

export default ToastInfo;